<template>
    <div class="filling-goods-div">
        <div style="padding-top: 10px; font-size: 16px">新建出库单</div>
        <div class="filling-goods-head-f">
            <div class="head-input-div-f" style="margin-bottom: 10px;">
                <div style="width: 20%; text-align: left">出库类型:</div>
                <input style="width: 50%;height: 25px; text-align: center;line-height: 25px;font-size: 16px;"
                    @click="TypePicker(0)" v-model="out_type" readonly="readonly" />
                <van-popup v-model="showPicker" position="bottom">
                    <van-picker :columns="returnList" show-toolbar @change="onChange" @confirm="onConfirms"
                        @cancel="onCancels"></van-picker>
                </van-popup>
            </div>
            <!-- <div class="head-input-div-f" style="margin-bottom: 10px;">
                <div style="width: 20%; text-align: left">退货方:</div>
                <input style="width: 50%;height: 25px; text-align: center;line-height: 25px;font-size: 16px;"
                    @click="TypePicker(1)" v-model="thf" readonly="readonly" />
                <van-popup v-model="SupplierPicker" position="bottom">
                    <van-picker :columns="SupplierList" show-toolbar @cancel="onCancel"
                        @confirm="onConfirm"></van-picker>
                </van-popup>
            </div> -->
            <div class="head-input-div-f">
                <div style="width: 20%; text-align: left">行数:</div>
                <input style="width: 80%;height: 25px;" readonly="readonly" :value="data.length" />
            </div>
            <!-- <div class="head-input-div-f">
          <div style="width: 20%; text-align: left">总数:</div>
          <input style="width: 80%" readonly="readonly" :value="allNum" />
        </div> -->
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center">
            <van-button type="info" size="small" style="display: flex" :text="ray" @click="holdRay()"></van-button>
            <div>
                <input id="scanQRCode" @keyup.enter="add_reel()" ref="getIDInpot" v-model="add_data"
                    placeholder="扫描卷号条码" v-on:blur="hideMessage()" readonly style="height: 30px; width: 150px"
                    autocomplete="off" />
            </div>
            <span style="color: red" v-if="hostcs">测试服</span>
        </div>
        <div :style="style">
            <div class="goods-info-two-f" v-for="(i, index) in data" :key="index">
                <div style="width: 100%; text-align: right">
                    <van-icon name="cross" @click="deleteData(index)" style="margin: 5px 5px 5px 0" size="20px" />
                </div>
                <div class="sp-db-h" style="padding-top: 0px;">
                    <div style="width: 50%; display: flex; align-items: center">
                        <div class="right-ret">卷号:</div>
                        <div style="font-size:16px;">{{ i.reel }}</div>
                    </div>
                    <div style="width: 50%; display: flex; align-items: center">
                        <div class="right-ret">门幅:</div>
                        <div style="font-size:16px;">{{ i.menfu }}</div>
                    </div>
                </div>
                <div class="sp-db-h">
                    <div style="width: 50%; display: flex; align-items: center">
                        <div class="right-ret">货号:</div>
                        <div style="font-size:16px;">{{ i.number }}</div>
                    </div>
                    <div style="width: 50%; display: flex; align-items: center">
                        <div class="right-ret">数量:</div>
                        <input type="text" v-model="i.store"
                            style="font-size: 16px; border: 1px solid #ccc; padding: 4px; width: 100px;" />
                    </div>
                </div>
                <div class="sp-db-h">
                    <div style="width: 50%; display: flex; align-items: center">
                        <div class="right-ret">规格:</div>
                        <div style="font-size:16px;">{{ i.size }}</div>
                    </div>
                    <div style="width: 50%; display: flex; align-items: center">
                        <div class="right-ret">仓库:</div>
                        <div style="font-size:16px;">{{ i.warehouse }} 米</div>
                    </div>
                </div>
                <div class="sp-db-h">
                    <div style="width: 50%; display: flex; align-items: center">
                        <div class="right-ret">卷号描述</div>
                        <div style="font-size:16px;">{{ i.reel_detail }}</div>
                    </div>

                </div>
                <!-- <div class="info-order-h">
                    <div style="width: 50%; display: flex">
                        <div class="right-ret">卷号</div>
                        <div class="data-order">{{ i.reel }}</div>
                    </div>
                    <div style="width: 50%; display: flex">
                        <div class="right-ret">卷号描述</div>
                        <div class="data-order">{{ i.reel_detail }}</div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="filling-goods-bottom" style="display: flex">
            <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
            <van-button type="info" class="bottom-button" @click="go_Submit()">提交</van-button>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
    name: "ReturnWarehouse",
    data() {
        return {
            hostcs: false,
            more_show: false,
            ray: "扫描中",
            parameterId: [],
            surplus: [],
            id: "",
            data: [],
            style: "",
            add_data: "",
            newData: {},
            add_data_all: {},
            newDataId: [],
            SupplierList: [],
            returnList: [
            ],
            out_type: '其他出库',
            thf: '',
            showPicker: false,
            SupplierPicker: false,
            ewmType: false,
            allNum: 0,
            GoodsType: false,
            revocationType: true,
            mather_id: "",
            getnumber: (i) => {
                if (i.indexOf("-") === -1) {
                    return i;
                } else {
                    return i.substr(0, i.indexOf("-"));
                }
            },
            warehouse: '',
        };
    },
    computed: {
        ...mapState({
            number: (state) => state.number,
            FGid: (state) => state.FGid,
            type: (state) => state.type,
        }),
    },
    mounted() {
        this.initdata();
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.style =
            "text-align: left;width: 100%;height: " + h * 0.78 + "px;overflow:scroll;";
        this.focus();
        setTimeout(() => {
            this.countAll();
        }, 500);
        if (window.location.host.indexOf("cspda") !== -1) {
            this.hostcs = true;
        }
    },
    methods: {
        ...mapMutations(["getNumber", "getFGid", "getType"]),
        create_fillingGoods(id) {
            Object.assign(this.$data, this.$options.data());
            this.$store.commit('getType', 'true')
            this.mather_id = id
        },
        fillingGoods(id) {
            this.mather_id = id
        },
        async initdata() {
            const datas = await this.get(this.APIOBJ.outboundList, {});

            if (datas.data.status == 1) {

                this.returnList = Object.values(datas.data.data.out_type);

            }

        },
        // async findS() {  //获取供应商
        //     let Supplier = await this.get(this.APIOBJ.fingSupplier, { type: this.out_type });
        //     this.SupplierList = Supplier.data.data
        //     console.log(Supplier)

        // },
        // handleRefresh() {
        //     this.$router.push("/fillingGoods?id=&FGid=&number=");
        //     window.location.reload();
        // },
        // getAdd() {
        //     //清楚数据
        //     this.add_data_all = {};
        //     this.data = [];
        //     this.allNum = 0;
        //     this.newDateId = [];
        //     this.$store.commit("getNumber", "");
        //     this.$store.commit("getType", "true");
        //     this.$store.commit("getFGid", "");
        //     this.mather_id = ''
        // },
        countAll() {
            this.allNum = 0;
            for (let i of this.data) {
                this.allNum += parseFloat(i.goods_count);
            }
        },
        hideMessage() {
            this.ray = "已暂停，点击我继续扫码";
            // this.focus();
        },
        holdRay() {
            this.ray = "扫描中";
            this.focus();
        },
        focus() {
            this.$refs.getIDInpot.focus();
            this.$refs.getIDInpot.setAttribute("readonly", "readonly");
            setTimeout(() => {
                this.$refs.getIDInpot.removeAttribute("readonly");
            }, 200);
        },
        TypePicker(index) {
            if (index == 1) {
                this.SupplierPicker = true;
            } else {
                this.showPicker = true;
            }
            // this.isDate = index;
        },
        onChange(picker, value, index) {
            this.focus();
            this.out_type = value;
            this.showPicker = false;
        },
        onConfirms(value, index) {
            this.focus();
            this.out_type = value;
            this.showPicker = false;
        },
        onCancels() {
            this.focus();
            this.showPicker = false;
        },
        // SSChange(picker, value, index) {
        //     this.thf = value;
        //     this.SupplierPicker = false;
        // },
        // onCancel() { this.SupplierPicker = false; },
        // onConfirm(value, index) {
        //     this.thf = value;
        //     this.SupplierPicker = false;
        // },
        async add_reel() {

            if (!navigator.onLine) {
                // 没有网络的时候
                Toast("当前网络故障");
                this.add_data = "";
                return;
            }
            if (this.add_data == "") {
                Toast("卷号不能为空");
                return;
            }
            if (this.data.some(item => item.reel === this.add_data)) {
                this.add_data = "";
                Toast("该卷号已存在，请勿重复扫码");
                return;
            }
            if (this.out_type == '') {
                Toast("所选出库类型为空");
                this.add_data = '';
                return;
            }
            let add_data = this.add_data;
            let datax = {
                reel: add_data,
            };
            document.getElementById("scanQRCode").disabled = true;
            let packings = await this.get(this.APIOBJ.getNormsware, datax);
            let packing = packings;

            if (packing.data.length == 0) {
                this.add_data = "";
                Toast("该卷号不存在");
                document.getElementById("scanQRCode").disabled = false;
                document.getElementById("scanQRCode").focus();
                return;
            }
            // if (this.thf != '' && this.thf != packing.data.supplier) {
            //     Toast("所选退货方和所扫卷号的供应商不一致");
            //     return;
            // }  11.29 启兰仓管关闭该功能
            var datay = {};
            datay.reel = packing.data.norms.reel;
            datay.menfu = packing.data.norms.menfu;
            datay.store = packing.data.norms.store;
            datay.number = packing.data.norms.number;
            datay.size = packing.data.norms.size;
            datay.batch = packing.data.norms.batch;
            datay.reel_detail = packing.data.norms.reel_detail;
            datay.warehouse = packing.data.norms.warehouse;
            datay.goods_count = packing.data.norms.goods_count;
            datay.goods = packing.data.norms.goods;
            datay.unit = packing.data.norms.unit;
            this.warehouse = packing.data.norms.warehouse;
            //this.thf = packing.data.supplier;  暂议
            document.getElementById("scanQRCode").disabled = false;
            document.getElementById("scanQRCode").focus();
            this.data = this.data.reverse();
            this.data.push(datay);
            this.data = this.data.reverse(); //装箱倒叙（倒序）代码，暂时注释，每次扫码都会对数据倒叙让使用者的体验不好
            this.add_data = "";
        },
        deleteData(index) {
            let name = this.data[index].reel
                ? this.data[index].reel
                : this.data[index].reel;
            Dialog.confirm({
                message: "确定要删除‘" + name + "’该卷号吗？",
            }).then(() => {
                Toast("已删除 " + name);
                this.data.splice(index, 1);
                this.countAll();
                if (this.id !== "") {
                    let id = this.id.replace(`${this.data[index].gck_number},`, "");
                    this.$route.query["id"] = id;
                    let query = { ...this.$route.query };
                    this.$router.replace({ query });
                }
            });
        },
        async go_Submit() {
            var username = JSON.parse(window.localStorage.getItem("userinfo"));

            // 检查提交状态，防止重复提交
            if (this.GoodsType) {
                return;
            }

            // 校验数据是否为空
            if (this.data.length === 0) {
                Toast("请填写出库数据后再提交！");
                return;
            }

            // 校验出库类型是否为空
            if (this.out_type === '') {
                Toast("请选择出库类型！");
                return;
            }
            const modifiedData = this.data.map(item => {
                const { store, ...rest } = item; // 解构获取 store 和其他属性
                return {
                    ...rest,       // 其他属性保持不变
                    num: store     // 将 store 重命名为 num
                };
            });

            // 构造提交数据
            let datax = {
                id: '',
                out_num: '',
                relevance: '',
                send_time: '',
                out_type: this.out_type,
                warehouse: this.warehouse,
                rowdata: JSON.stringify(modifiedData),
                remark: '',
                user_name: username,
            };

            // 标记已提交状态，防止重复点击
            this.GoodsType = true;

            try {
                // 使用 fetch 发送 POST 请求
                const response = await fetch(window.localStorage.getItem('pdaBASEURL') + this.APIOBJ.doOut, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    //mode: "no-cors",
                    //cache: "force-cache"
                    body: new URLSearchParams(datax).toString(),
                });

                // 检查 HTTP 响应是否成功
                if (!response.ok) {
                    throw new Error(`HTTP 错误！状态码：${response.status}`);
                }

                // 获取响应并解析为 JSON
                const res = await response.json();

                // 根据服务器返回的状态处理
                if (res.status === 1) {
                    Toast("出库成功！");
                    this.data = []; // 清空数据
                    this.out_type = '其他出库'; // 重置出库类型
                    this.holdRay(); // 执行回调（假设这是你的逻辑）

                } else {
                    Toast(res.msg || "保存失败，请重试！");
                }
            } catch (error) {
                // 捕获网络错误或其他异常
                console.error("提交时发生错误：", error);
                Toast("提交失败，请检查网络或稍后重试！");
            } finally {
                // 恢复提交状态
                this.GoodsType = false;
            }
        },

        // go_scan_url() {
        //     let url =
        //         "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
        //     window.location.href = url;
        // },
        go_index() {
            Dialog.confirm({
                message: "确定要回首页吗？",
            })
                .then(() => {
                    this.$router.push("/home");
                })
                .catch(() => {
                    // on cancel
                });
        },
    },
};
</script>

<style lang="less">
.head-input-div-f {
    display: flex;
    width: 100%;
    align-items: center;
    position: relative;
}

.filling-goods-head-f {
    padding: 10px 0;
}

.filling-goods-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    margin-left: -10px;
}

.info-order {
    width: 100%;
    display: flex;
    background-color: white;
    margin: 5px 0;
    padding: 10px 0;
}

.goods-info-two-f {
    margin-top: 10px;
    background-color: #f2f2f2;
    padding-bottom: 10px;
}

.bottom-button {
    width: 25%;
}

.info-order-h {
    width: 100%;
    display: flex;
    padding-top: 5px;
}

.order-info-input {
    border-radius: 5px;
    border: 1px solid #444444;
    text-align: center;
    width: 4.5rem;
}

.info-order-data {
    width: 65%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.info-order-title {
    width: 35%;
}

.an-niu {
    border-radius: 5px;
    font-size: 12px;
}

.right-ret {
    // width: 1.6rem;
    font-size: 16px;
    margin: 0 15px;
    text-align: left;
}

.goods-info {
    margin-top: 10px;
    height: 300px;
    background-color: #f2f2f2;
}

.SbuttonDiv {
    position: fixed;
    bottom: 0;
    width: 100%;
    margin: 0 -10px;
}

.sp-db-h {
    width: 100%;
    padding-top: 10px;
    display: flex;
}

.more-class {
    border-top: 0.5px solid #444444;
}

.vatDia {
    color: #f2f2f2 !important;
    background-color: #f80b0b !important;
    font-size: 18px !important;
}

.vatDia .van-dialog__cancel .van-button__text {
    font-size: 18px;
    /* 根据需求调整字体大小 */
}

.vatDia .van-dialog__cancel {
    background-color: #f80b0b;
    color: #f2f2f2;
}

.vatDia .van-dialog__message {
    font-size: 18px;
}
</style>